export const blogCategoriesData = [
    {
      key: "1",
      CATEGORY: "Travel Tips",
      NUMBEROFBLOGS: "15",
      CREATEDDATE: "24 Jan 2025",
      STATUS: "Published",
    },
    {
      key: "2",
      CATEGORY: "Car Reviews",
      NUMBEROFBLOGS: "13",
      CREATEDDATE: "19 Dec 2024",
      STATUS: "Unpublish",
    },
    {
      key: "3",
      CATEGORY: "Rental Policies",
      NUMBEROFBLOGS: "4",
      CREATEDDATE: "11 Dec 2024",
      STATUS: "Published",
    },
    {
      key: "4",
      CATEGORY: "Insurance & Coverage",
      NUMBEROFBLOGS: "9",
      CREATEDDATE: "29 Nov 2024",
      STATUS: "Published",
    },
    {
      key: "5",
      CATEGORY: "Budget Rentals",
      NUMBEROFBLOGS: "19",
      CREATEDDATE: "03 Nov 2024",
      STATUS: "Published",
    },
    {
      key: "6",
      CATEGORY: "Luxury Car Rentals",
      NUMBEROFBLOGS: "17",
      CREATEDDATE: "31 Oct 2024",
      STATUS: "Published",
    },
    {
      key: "7",
      CATEGORY: "Road Trip Guides",
      NUMBEROFBLOGS: "6",
      CREATEDDATE: "15 Oct 2024",
      STATUS: "Unpublish",
    },
    {
      key: "8",
      CATEGORY: "Eco-Friendly Rentals",
      NUMBEROFBLOGS: "25",
      CREATEDDATE: "26 Sep 2024",
      STATUS: "Unpublish",
    },
    {
      key: "9",
      CATEGORY: "Seasonal Deals",
      NUMBEROFBLOGS: "18",
      CREATEDDATE: "01 Sep 2024",
      STATUS: "Published",
    },
    {
      key: "10",
      CATEGORY: "Customer Stories",
      NUMBEROFBLOGS: "18",
      CREATEDDATE: "15 Aug 2024",
      STATUS: "Published",
    },
    {
      key: "11",
      CATEGORY: "Budget Rentals",
      NUMBEROFBLOGS: "22",
      CREATEDDATE: "15 Aug 2024",
      STATUS: "Published",
    },
];